import angular from 'angular';
import uiRouter from 'angular-ui-router';
import clientDashboardComponent from './clientDashboard.component';

let clientDashboardModule = angular.module('clientDashboard', [
  uiRouter
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('/');

  $stateProvider
    .state('clientDashboard', {
      url: '/client-dashboard',
      component: 'clientDashboard'
    });
})

.component('clientDashboard', clientDashboardComponent)

.name;

export default clientDashboardModule;



// WEBPACK FOOTER //
// ./src/app/pages/clientDashboard/clientDashboard.js